import { Customer } from "../customer/Customer"
import { CustomerOrderBuildStepDetails } from "./CustomerOrderBuildStepDetails"
import { CustomerOrderPartDetails } from "./CustomerOrderPartDetails"
import { CustomerOrderPaymentDetails } from "./CustomerOrderPaymentDetails"
import { CustomerOrderServiceDetails } from "./CustomerOrderServiceDetails"

export class CustomerOrderDetails {
  id: number
  buildSteps: CustomerOrderBuildStepDetails[]
  buildTypeName: string
  cartridgeName: string
  customer: Customer
  customerSuppliedParts: string
  parts: CustomerOrderPartDetails[]
  partsDiscountPercentage: number
  payments: CustomerOrderPaymentDetails[]
  scheduledDate?: string
  services: CustomerOrderServiceDetails[]
  servicesDiscountPercentage: number
  total: number
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, buildStepsJson: any, buildTypeName: string, cartridgeName: string, customer: Customer, customerSuppliedParts: string, partsJson: any, partsDiscountPercentage: number, paymentsJson: any, scheduledDate: string|undefined, servicesJson: any, servicesDiscountPercentage: number, total: number) {
    this.id = id

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.buildSteps = buildStepsJson ? buildStepsJson.map((o: any) => new CustomerOrderBuildStepDetails(o.processName, o.processStatus)) : []

    this.buildTypeName = buildTypeName
    this.cartridgeName = cartridgeName
    this.customer = customer
    this.customerSuppliedParts = customerSuppliedParts

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.parts = partsJson ? partsJson.map((o: any) => new CustomerOrderPartDetails(o.displayOrder, o.name, o.notes, o.price, o.status)) : []

    this.partsDiscountPercentage = partsDiscountPercentage

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.payments = paymentsJson ? paymentsJson.map((o: any) => new CustomerOrderPaymentDetails(o.amount, o.receivedDate)) : []
    
    this.scheduledDate = scheduledDate

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.services = servicesJson ? servicesJson.map((o: any) => new CustomerOrderServiceDetails(o.completed, o.description, o.name, o.notes, o.price, o.serviceFieldValues)) : []

    this.servicesDiscountPercentage = servicesDiscountPercentage
    this.total = total
  }
}
